// import SignupSaga from './registro/sagas'
import LoginSaga from "./sagas/login_sagas"
import SourcesSaga from "./sagas/sources_sagas"
import ConceptsSaga from "./sagas/concepts_sagas"
import SearchSaga from "./sagas/search_sagas"
import SavedSearchSaga from "./sagas/savedSearch_sagas"
import TimelineSaga from "./sagas/timeline_sagas"
import BuildSaga from "./sagas/build_sagas"
import ViewDocumentsSaga from "./sagas/viewDocuments_sagas"
import JobsSaga from "./sagas/jobs_sagas"
import DocumentsSaga from "./sagas/documents_sagas"
import multiAiBaseSaga from "./sagas/multibase_sagas"
import documentsSagas from "./sagas/documentsSagas"
import bifrostSagas from "./sagas/bifrost_sagas"
import bifrostCaseSagas from "./sagas/bifrostCase_sagas"
import documentModalSagas from "./sagas/documentModalSagas"
import fileListSaga from "./sagas/fileList_sagas"
import bifrostCaseDetailsSaga from "./sagas/bifrostCaseDetails_sagas"
import bifrostExtractDetailsSaga from "./sagas/bifrostExtractJobDetails_sagas"
import bifrostUploadDetailsSaga from "./sagas/bifrostUploadJobDetails_sagas"
import bifrostKbMakingDetailsSaga from "./sagas/bifrostKbMakingDetails_sagas"
import bifrostPiiDetailsSaga from "./sagas/bifrostPiiDetails_sagas"
import dashboardSaga from "./sagas/dashboard_sagas"
import reviewSagas from "./sagas/review_sagas"
// import DatosCuenta from './datoscuenta/sagas'
// import DasboardInfluencer from './dashboard_influencer/sagas'
// import Planes from './planes_comprar/sagas'
// import RecoverySaga from './password_recovery/sagas'
import { all } from "redux-saga/effects"

import usersSaga from "./sagas/user_sagas"
import infoSaga from "./sagas/info_sagas"
import viewerSaga from "./sagas/viewer_sagas"
import userManagementSaga from "./sagas/users_sagas"
import auditSaga from "./sagas/audit_sagas"
import headerSaga from "./sagas/header_sagas"
import billingSagas from "./sagas/billing_sagas"
import eventSagas from "./sagas/event_sagas"
import taggedDateSagas from "./sagas/taggedDate_sagas"
import uploadSagas from "./sagas/upload_sagas"

export default function* IndexSaga() {
	yield all([
		LoginSaga(),
		SourcesSaga(),
		ConceptsSaga(),
		SearchSaga(),
		SavedSearchSaga(),
		TimelineSaga(),
		BuildSaga(),
		ViewDocumentsSaga(),
		JobsSaga(),
		DocumentsSaga(),
		multiAiBaseSaga(),
		documentsSagas(),
		bifrostSagas(),
		documentModalSagas(),
		bifrostCaseSagas(),
		fileListSaga(),
		usersSaga(),
		infoSaga(),
		bifrostCaseDetailsSaga(),
		bifrostExtractDetailsSaga(),
		bifrostUploadDetailsSaga(),
		bifrostKbMakingDetailsSaga(),
		viewerSaga(),
		dashboardSaga(),
		userManagementSaga(),
		reviewSagas(),
		auditSaga(),
		bifrostPiiDetailsSaga(),
		headerSaga(),
		billingSagas(),
		eventSagas(),
		taggedDateSagas(),
		uploadSagas(),
	])
}
